export default "__VITE_ASSET__cf66f903__"